import _toConsumableArray from "/home/patrick/jamespatrickleduc.github.io/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/patrick/jamespatrickleduc.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/patrick/jamespatrickleduc.github.io/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { line as _line, solidFillPolygon, patternFillPolygon, rectangle as _rectangle, ellipseWithParams, generateEllipseParams, linearPath as _linearPath, arc as _arc, patternFillArc, curve as _curve, svgPath } from './renderer.js';
import { randomSeed } from './math.js';
import { curveToBezier } from 'points-on-curve/lib/curve-to-bezier.js';
import { pointsOnBezierCurves } from 'points-on-curve';
import { pointsOnPath } from 'points-on-path';
var NOS = 'none';
export var RoughGenerator = /*#__PURE__*/function () {
  function RoughGenerator(config) {
    _classCallCheck(this, RoughGenerator);

    this.defaultOptions = {
      maxRandomnessOffset: 2,
      roughness: 1,
      bowing: 1,
      stroke: '#000',
      strokeWidth: 1,
      curveTightness: 0,
      curveFitting: 0.95,
      curveStepCount: 9,
      fillStyle: 'hachure',
      fillWeight: -1,
      hachureAngle: -41,
      hachureGap: -1,
      dashOffset: -1,
      dashGap: -1,
      zigzagOffset: -1,
      seed: 0,
      combineNestedSvgPaths: false,
      disableMultiStroke: false,
      disableMultiStrokeFill: false
    };
    this.config = config || {};

    if (this.config.options) {
      this.defaultOptions = this._o(this.config.options);
    }
  }

  _createClass(RoughGenerator, [{
    key: "_o",
    value: function _o(options) {
      return options ? Object.assign({}, this.defaultOptions, options) : this.defaultOptions;
    }
  }, {
    key: "_d",
    value: function _d(shape, sets, options) {
      return {
        shape: shape,
        sets: sets || [],
        options: options || this.defaultOptions
      };
    }
  }, {
    key: "line",
    value: function line(x1, y1, x2, y2, options) {
      var o = this._o(options);

      return this._d('line', [_line(x1, y1, x2, y2, o)], o);
    }
  }, {
    key: "rectangle",
    value: function rectangle(x, y, width, height, options) {
      var o = this._o(options);

      var paths = [];

      var outline = _rectangle(x, y, width, height, o);

      if (o.fill) {
        var points = [[x, y], [x + width, y], [x + width, y + height], [x, y + height]];

        if (o.fillStyle === 'solid') {
          paths.push(solidFillPolygon(points, o));
        } else {
          paths.push(patternFillPolygon(points, o));
        }
      }

      if (o.stroke !== NOS) {
        paths.push(outline);
      }

      return this._d('rectangle', paths, o);
    }
  }, {
    key: "ellipse",
    value: function ellipse(x, y, width, height, options) {
      var o = this._o(options);

      var paths = [];
      var ellipseParams = generateEllipseParams(width, height, o);
      var ellipseResponse = ellipseWithParams(x, y, o, ellipseParams);

      if (o.fill) {
        if (o.fillStyle === 'solid') {
          var shape = ellipseWithParams(x, y, o, ellipseParams).opset;
          shape.type = 'fillPath';
          paths.push(shape);
        } else {
          paths.push(patternFillPolygon(ellipseResponse.estimatedPoints, o));
        }
      }

      if (o.stroke !== NOS) {
        paths.push(ellipseResponse.opset);
      }

      return this._d('ellipse', paths, o);
    }
  }, {
    key: "circle",
    value: function circle(x, y, diameter, options) {
      var ret = this.ellipse(x, y, diameter, diameter, options);
      ret.shape = 'circle';
      return ret;
    }
  }, {
    key: "linearPath",
    value: function linearPath(points, options) {
      var o = this._o(options);

      return this._d('linearPath', [_linearPath(points, false, o)], o);
    }
  }, {
    key: "arc",
    value: function arc(x, y, width, height, start, stop) {
      var closed = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      var options = arguments.length > 7 ? arguments[7] : undefined;

      var o = this._o(options);

      var paths = [];

      var outline = _arc(x, y, width, height, start, stop, closed, true, o);

      if (closed && o.fill) {
        if (o.fillStyle === 'solid') {
          var shape = _arc(x, y, width, height, start, stop, true, false, o);

          shape.type = 'fillPath';
          paths.push(shape);
        } else {
          paths.push(patternFillArc(x, y, width, height, start, stop, o));
        }
      }

      if (o.stroke !== NOS) {
        paths.push(outline);
      }

      return this._d('arc', paths, o);
    }
  }, {
    key: "curve",
    value: function curve(points, options) {
      var o = this._o(options);

      var paths = [];

      var outline = _curve(points, o);

      if (o.fill && o.fill !== NOS && points.length >= 3) {
        var bcurve = curveToBezier(points);
        var polyPoints = pointsOnBezierCurves(bcurve, 10, (1 + o.roughness) / 2);

        if (o.fillStyle === 'solid') {
          paths.push(solidFillPolygon(polyPoints, o));
        } else {
          paths.push(patternFillPolygon(polyPoints, o));
        }
      }

      if (o.stroke !== NOS) {
        paths.push(outline);
      }

      return this._d('curve', paths, o);
    }
  }, {
    key: "polygon",
    value: function polygon(points, options) {
      var o = this._o(options);

      var paths = [];

      var outline = _linearPath(points, true, o);

      if (o.fill) {
        if (o.fillStyle === 'solid') {
          paths.push(solidFillPolygon(points, o));
        } else {
          paths.push(patternFillPolygon(points, o));
        }
      }

      if (o.stroke !== NOS) {
        paths.push(outline);
      }

      return this._d('polygon', paths, o);
    }
  }, {
    key: "path",
    value: function path(d, options) {
      var o = this._o(options);

      var paths = [];

      if (!d) {
        return this._d('path', paths, o);
      }

      d = (d || '').replace(/\n/g, ' ').replace(/(-\s)/g, '-').replace('/(\s\s)/g', ' ');
      var hasFill = o.fill && o.fill !== 'transparent' && o.fill !== NOS;
      var hasStroke = o.stroke !== NOS;
      var simplified = !!(o.simplification && o.simplification < 1);
      var distance = simplified ? 4 - 4 * o.simplification : (1 + o.roughness) / 2;
      var sets = pointsOnPath(d, 1, distance);

      if (hasFill) {
        if (o.combineNestedSvgPaths) {
          var combined = [];
          sets.forEach(function (set) {
            return combined.push.apply(combined, _toConsumableArray(set));
          });

          if (o.fillStyle === 'solid') {
            paths.push(solidFillPolygon(combined, o));
          } else {
            paths.push(patternFillPolygon(combined, o));
          }
        } else {
          sets.forEach(function (polyPoints) {
            if (o.fillStyle === 'solid') {
              paths.push(solidFillPolygon(polyPoints, o));
            } else {
              paths.push(patternFillPolygon(polyPoints, o));
            }
          });
        }
      }

      if (hasStroke) {
        if (simplified) {
          sets.forEach(function (set) {
            paths.push(_linearPath(set, false, o));
          });
        } else {
          paths.push(svgPath(d, o));
        }
      }

      return this._d('path', paths, o);
    }
  }, {
    key: "opsToPath",
    value: function opsToPath(drawing) {
      var path = '';

      var _iterator = _createForOfIteratorHelper(drawing.ops),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var data = item.data;

          switch (item.op) {
            case 'move':
              path += "M".concat(data[0], " ").concat(data[1], " ");
              break;

            case 'bcurveTo':
              path += "C".concat(data[0], " ").concat(data[1], ", ").concat(data[2], " ").concat(data[3], ", ").concat(data[4], " ").concat(data[5], " ");
              break;

            case 'lineTo':
              path += "L".concat(data[0], " ").concat(data[1], " ");
              break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return path.trim();
    }
  }, {
    key: "toPaths",
    value: function toPaths(drawable) {
      var sets = drawable.sets || [];
      var o = drawable.options || this.defaultOptions;
      var paths = [];

      var _iterator2 = _createForOfIteratorHelper(sets),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var drawing = _step2.value;
          var path = null;

          switch (drawing.type) {
            case 'path':
              path = {
                d: this.opsToPath(drawing),
                stroke: o.stroke,
                strokeWidth: o.strokeWidth,
                fill: NOS
              };
              break;

            case 'fillPath':
              path = {
                d: this.opsToPath(drawing),
                stroke: NOS,
                strokeWidth: 0,
                fill: o.fill || NOS
              };
              break;

            case 'fillSketch':
              path = this.fillSketch(drawing, o);
              break;
          }

          if (path) {
            paths.push(path);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return paths;
    }
  }, {
    key: "fillSketch",
    value: function fillSketch(drawing, o) {
      var fweight = o.fillWeight;

      if (fweight < 0) {
        fweight = o.strokeWidth / 2;
      }

      return {
        d: this.opsToPath(drawing),
        stroke: o.fill || NOS,
        strokeWidth: fweight,
        fill: NOS
      };
    }
  }], [{
    key: "newSeed",
    value: function newSeed() {
      return randomSeed();
    }
  }]);

  return RoughGenerator;
}();